<template>
	<div class="container-scripts">
		<h2 class="heading-2 global-box-heading">{{ $t('scripts') }}</h2>
		<ja-textarea
			v-model="scriptsData.transitionHeading"
			:max-length="textAreaMaxLength"
			is-legend
			:label="$t('researchPopupHeading')"
			:name="$t('researchPopupHeading')"
			@blur="handleBlur"
		></ja-textarea>
		<ja-textarea
			v-model="scriptsData.transitionSupportText"
			:max-length="textAreaMaxLength"
			is-legend
			:label="$t('researchPopupSupporting')"
			:name="$t('researchPopupSupporting')"
			@blur="handleBlur"
		></ja-textarea>
		<ja-textarea
			v-model="scriptsData.researchHeader"
			:max-length="textAreaMaxLength"
			is-legend
			:label="$t('researchHeader')"
			:name="$t('researchHeader')"
			@blur="handleBlur"
		></ja-textarea>
		<div>
			<h2 class="heading-5">{{ $t('sponsorLogos') }}</h2>
			<div class="container-buttons-logos">
				<div
					v-for="(_, index) in sponsorLogosButtons"
					:key="index"
					class="button-container"
				>
					<div class="select-file">
						<ja-button
							name="selectFile"
							class="small outlined"
							@click.native="openFileSelector(index)"
							>{{ $t('selectFile') }}</ja-button
						>
						<img
							v-show="sponsorLogosURLS[index].imageBase64"
							ref="imageLogo"
							:src="sponsorLogosURLS[index].imageBase64"
							:alt="'logo' + [index + 1]"
							class="thumbnail"
						/>
						<span v-show="!sponsorLogosURLS[index].imageBase64">{{
							$t('chooseALogo')
						}}</span>
						<input
							ref="fileInput"
							type="file"
							style="display: none;"
							accept=".png, .jpg, .jpeg"
							@change="validateFile($event, index)"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { Textarea } from '@/components/ui/form/';
import Button from '@/components/ui/Button';
import { ResizeImage } from '@/mixins';
import { cmsTextAreaMaxLength } from '@/helpers/constants';

export default {
	components: {
		jaTextarea: Textarea,
		jaButton: Button
	},
	mixins: [ResizeImage],
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			sponsorLogosButtons: [],
			scriptsData: null,
			sponsorLogosURLS: [],
			fileInfo: [],
			fileValid: [],
			textAreaMaxLength: cmsTextAreaMaxLength.SCRIPT_FORM_LENGTH
		};
	},
	created() {
		this.scriptsData = this.data;
		const emptyLogo = this.scriptsData.cmsExpenseCategoryLogoEmpty;
		emptyLogo.expenseCategory_ID = this.scriptsData.expenseCategory_ID;
		this.sponsorLogosButtons = [null, null, null, null];
		this.sponsorLogosURLS = this.sponsorLogosButtons.map(() => {
			return { ...emptyLogo };
		});
		this.fileInfo = this.sponsorLogosButtons.map(() => false);
		this.fileValid = this.sponsorLogosButtons.map(() => false);
		this.setInitialValues();
	},
	methods: {
		setInitialValues() {
			const emptyLogo = this.scriptsData.cmsExpenseCategoryLogoEmpty;
			emptyLogo.expenseCategory_ID = this.scriptsData.expenseCategory_ID;

			if (this.scriptsData.cmsExpenseCategoryLogos.length > 0) {
				this.sponsorLogosURLS.forEach((_, index) => {
					if (index < this.scriptsData.cmsExpenseCategoryLogos.length) {
						this.sponsorLogosURLS[index] = this.scriptsData
							.cmsExpenseCategoryLogos[index] ?? { ...emptyLogo };
					}
				});
			} else {
				this.sponsorLogosURLS.forEach((_, index) => {
					this.sponsorLogosURLS[index] = { ...emptyLogo };
				});
			}
		},
		openFileSelector(index) {
			const fileInput = this.$refs.fileInput[index];
			if (fileInput) {
				fileInput.click();
			}
		},
		async readFileAsync(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = () => {
					resolve(reader.result);
				};
				reader.onerror = reject;
				reader.readAsDataURL(file);
			});
		},
		async imageSize(file) {
			const maxLogoWidth = 165;
			const maxLogoHeight = 66;
			let fileDataURL = file;
			const resizedFile = await this.resizeImage(
				file,
				maxLogoWidth,
				maxLogoHeight
			);
			fileDataURL = await this.readFileAsync(resizedFile);

			return fileDataURL;
		},
		async validateFile(event, index) {
			const input = event.target;
			const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg'];

			const file = input.files[0];

			if (file) {
				this.fileInfo[index] = file.name;
				if (!allowedTypes.includes(file.type)) {
					this.fileValid[index] = false;
					return;
				}

				const resizedDataURL = await this.imageSize(file);
				this.sponsorLogosURLS[index].imageBase64 = resizedDataURL;
				this.handleBlur();
				this.$forceUpdate();

				this.fileValid[index] = true;
			}
		},
		handleBlur() {
			this.sponsorLogosURLS.forEach((item, index) => {
				if (item.imageBase64 !== null) {
					if (this.scriptsData.cmsExpenseCategoryLogos[index]) {
						this.$set(this.scriptsData.cmsExpenseCategoryLogos, index, item);
					} else {
						this.scriptsData.cmsExpenseCategoryLogos.push(item);
					}
				}
			});
			this.$emit('scriptsData', this.scriptsData);
		}
	}
};
</script>
<style lang="scss" scoped>
.container-scripts {
	display: flex;
	flex-direction: column;
	margin-top: 60px;
}
.select-file {
	display: flex;
	align-items: center;
	gap: 10px;
	height: 60%;
}
.file-info {
	display: flex;
	flex-direction: column;
	gap: 5px;
}
.container-buttons-logos {
	display: flex;
	height: 100px;
}
.thumbnail {
	width: 50px;
	height: auto;
	margin: 5px;
}
.button-container {
	flex-basis: 25%;
	height: 100%;
}
.heading-5 {
	color: $font-dark;
	margin: 10px 0;
}
.text--warning {
	margin: 0 10px;
	display: block;
}

::v-deep label .heading-5 {
	margin-bottom: 20px;
}
</style>
